import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type LinkVendorToRampVendorMutationVariables = Types.Exact<{
  input: Types.LinkVendorToRampVendorInput;
}>;


export type LinkVendorToRampVendorMutation = { __typename?: 'Mutation', linkVendorToRampVendor: { __typename?: 'VendorPayload', vendor?: { __typename?: 'VendorStateData', id: string, rampVendorId?: string | null, rampVendor?: { __typename?: 'RampVendorData', rampVendorId: string, name: string, isActive: boolean } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UnlinkVendorFromRampVendorMutationVariables = Types.Exact<{
  input: Types.UnlinkVendorFromRampVendorInput;
}>;


export type UnlinkVendorFromRampVendorMutation = { __typename?: 'Mutation', unlinkVendorFromRampVendor: { __typename?: 'VendorPayload', vendor?: { __typename?: 'VendorStateData', id: string, rampVendorId?: string | null, rampVendor?: { __typename?: 'RampVendorData', rampVendorId: string, name: string, isActive: boolean } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LinkSuggestedRampVendorsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LinkSuggestedRampVendorsMutation = { __typename?: 'Mutation', linkSuggestedRampVendors: { __typename?: 'LinkSuggestedRampVendorsPayload', linkedCount: number, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const LinkVendorToRampVendorDocument = new TypedDocumentString(`
    mutation LinkVendorToRampVendor($input: LinkVendorToRampVendorInput!) {
  linkVendorToRampVendor(input: $input) {
    vendor {
      ...VendorRampLinkFields
    }
    errors {
      code
      message
    }
  }
}
    fragment VendorRampLinkFields on VendorStateData {
  id
  rampVendorId
  rampVendor {
    ...RampVendorFields
  }
}
fragment RampVendorFields on RampVendorData {
  rampVendorId
  name
  isActive
}`);
export const UnlinkVendorFromRampVendorDocument = new TypedDocumentString(`
    mutation UnlinkVendorFromRampVendor($input: UnlinkVendorFromRampVendorInput!) {
  unlinkVendorFromRampVendor(input: $input) {
    vendor {
      ...VendorRampLinkFields
    }
    errors {
      code
      message
    }
  }
}
    fragment VendorRampLinkFields on VendorStateData {
  id
  rampVendorId
  rampVendor {
    ...RampVendorFields
  }
}
fragment RampVendorFields on RampVendorData {
  rampVendorId
  name
  isActive
}`);
export const LinkSuggestedRampVendorsDocument = new TypedDocumentString(`
    mutation LinkSuggestedRampVendors {
  linkSuggestedRampVendors {
    linkedCount
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    LinkVendorToRampVendor: build.mutation<LinkVendorToRampVendorMutation, LinkVendorToRampVendorMutationVariables>({
      query: (variables) => ({ document: LinkVendorToRampVendorDocument, variables })
    }),
    UnlinkVendorFromRampVendor: build.mutation<UnlinkVendorFromRampVendorMutation, UnlinkVendorFromRampVendorMutationVariables>({
      query: (variables) => ({ document: UnlinkVendorFromRampVendorDocument, variables })
    }),
    LinkSuggestedRampVendors: build.mutation<LinkSuggestedRampVendorsMutation, LinkSuggestedRampVendorsMutationVariables | void>({
      query: (variables) => ({ document: LinkSuggestedRampVendorsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useLinkVendorToRampVendorMutation, useUnlinkVendorFromRampVendorMutation, useLinkSuggestedRampVendorsMutation } = injectedRtkApi;
